import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxButtonComponent } from './rx-button.component';
import { RxIconModule } from '../rx-icon/rx-icon.module';

@NgModule({
  imports: [CommonModule, RxIconModule, RxButtonComponent],
  exports: [RxButtonComponent],
})
export class RxButtonModule {}
